module.exports = __webpack_public_path__ + "static/media/inward_logo.e2d5fd2d.svg";